module.exports = __webpack_public_path__ + "img/tether-usdt-logo.a440d4b5.png";